import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import ItemService from "../../services/supplier_appCommonService";
import Loader from "../Loader";
import toast from "react-hot-toast";
import FileThumbnailForHB from "./FileThumbnailForHB";
import { Col } from "react-bootstrap";

const FileViewerModalForHB = React.forwardRef((props, ref) => {
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState(false);
  const loadUploadedFiles = async (attachmentIds) => {
    if (!attachmentIds) return;

    setStatus(true);

    try {
      // ✅ Ensure it's always an array
      const ids = Array.isArray(attachmentIds)
        ? attachmentIds
        : [attachmentIds];

      let allFiles = [];

      // ✅ Loop through each ID
      for (let id of ids) {
        const payload = { attachmentId: id, timeZone: "Asia/Calcutta" };
        const res = await ItemService.getUploadedFiles(payload);

        const uploadedFiles = res?.data || [];

        const filesWithUniqueIds = uploadedFiles.map((file, idx) => ({
          ...file,
          _uniqueId: file.newFilename || file.fileName || `${id}-${idx}`, // ✅ per-file unique
          attachmentId: id,
        }));

        allFiles = [...allFiles, ...filesWithUniqueIds];
      }

      setFiles(allFiles);
    } catch (err) {
      console.error("Error loading files:", err);
      toast.error("Failed to load files");
    }

    setStatus(false);
  };

  const handleDelete = async (file) => {
    const payload = {
      fileName: file.newFilename || file.fileName,
      attachmentId: file.attachmentId,
    };

    try {
      const res = await ItemService.deleteFile(payload);

      if (res.status === 200 || res.message?.includes("deleted successfully")) {
        toast.success("File deleted successfully");

        // ✅ Now filters correctly because _uniqueId = newFilename (unique per file)
        const updatedFiles = files.filter(
          (f) => f._uniqueId !== file._uniqueId,
        );

        setFiles(updatedFiles);

        if (props.onDeleteSuccess) {
          props.onDeleteSuccess({
            attachmentId: file.attachmentId,
            hasFiles: updatedFiles.length > 0,
            remainingCount: updatedFiles.length,
          });
        }
      }
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Delete failed");
    }
  };
  useEffect(() => {
    if (props.show && props.fileid) {
      loadUploadedFiles(props.fileid);
    } else {
      // ✅ Reset when modal closes
      setFiles([]);
    }
  }, [props.fileid, props.show]);

  return (
    <Modal
      {...props}
      dialogClassName="modal-90w"
      keyboard={false}
      centered
      backdrop="static"
      size="lg"
      ref={ref}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Attachment Files ({files.length} file{files.length !== 1 ? "s" : ""})
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col>
            {" "}
            <Loader isLoading={status} />
            {!status && files.length > 0 ? (
              <FileThumbnailForHB files={files || []} onDelete={handleDelete} showDelete={props.showDelete ?? true} />
            ) : !status ? (
              <div
                style={{ padding: "20px", textAlign: "center", color: "#666" }}
              >
                No files uploaded
              </div>
            ) : null}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default FileViewerModalForHB;
